import { Application } from '@hotwired/stimulus';
import ComboboxController from './combobox_controller.js';
import TabsController from './tabs_controller.js';
import CartController from './cart_controller.js';
import LeadTableController from './lead_table_controller.js';
import PreviewController from './preview_controller.js';
import CatalogController from './catalog_controller.js';
import OrdersController from './orders_controller.js';
import ComplaintsController from './complaints_controller.js';
import CreditsController from './credits_controller.js';
import BackorderController from './backorder_controller.js';
import AuthLogController from './auth_log_controller.js';
import DashboardController from './dashboard_controller.js';
import PhoneVerifyController from './phone_verify_controller.js';
import AccountController from './account_controller.js';
import CrudController from './crud_controller.js';
import LeadAdminController from './lead_admin_controller.js';
import LeadWizardController from './lead_wizard_controller.js';
import SubcategoryAdminController from './subcategory_admin_controller.js';
import StaffClientsController from './staff_clients_controller.js';
import ClientsKpiController from './clients_kpi_controller.js';
import HelpdeskController from './helpdesk_controller.js';
import HelpdeskBadgeController from './helpdesk_badge_controller.js';
import WalletBalanceController from './wallet_balance_controller.js';
import DismissController from './dismiss_controller.js'
import SubcatSearchController from './subcat_search_controller.js';
import ContactFormController from './contact_form_controller.js';
import FavoriteHeartController from './favorite_heart_controller.js';
import NotificationsController from './notifications_controller.js';
import NotificationBadgeController from './notification_badge_controller.js';
import TagChipsController from './tag_chips_controller.js';
import ManagementVerticalsController from './management_verticals_controller.js';
import OrgSwitcherController from './org_switcher_controller.js';
import LeadEntrySwitchController from './lead_entry_switch_controller.js';
import InsuranceLeadController from './insurance_lead_controller.js';
import PurchasedAdminController from './purchased_admin_controller.js';
import DemandController from './demand_controller.js';
import DemandStaffController from './demand_staff_controller.js';

const application = Application.start();
application.register('combobox', ComboboxController);
application.register('tabs', TabsController);
application.register('cart', CartController);
application.register('lead-table', LeadTableController);
application.register('preview', PreviewController);
application.register('catalog', CatalogController);
application.register('orders', OrdersController);
application.register('complaints', ComplaintsController);
application.register('credits', CreditsController);
application.register('backorder', BackorderController);
application.register('auth-log', AuthLogController);
application.register('dashboard', DashboardController);
application.register('phone-verify', PhoneVerifyController);
application.register('account', AccountController);
application.register('crud', CrudController);
application.register('lead-admin', LeadAdminController);
application.register('lead-wizard', LeadWizardController);
application.register('subcategory-admin', SubcategoryAdminController);
application.register('staff-clients', StaffClientsController);
application.register('clients-kpi', ClientsKpiController);
application.register('helpdesk', HelpdeskController);
application.register('helpdesk-badge', HelpdeskBadgeController);
application.register('wallet-balance', WalletBalanceController);
application.register('dismiss', DismissController);
application.register('subcat-search', SubcatSearchController);
application.register('contact-form', ContactFormController);
application.register('favorite-heart', FavoriteHeartController);
application.register('notifications', NotificationsController);
application.register('notification-badge', NotificationBadgeController);
application.register('tag-chips', TagChipsController);
application.register('management-verticals', ManagementVerticalsController);
application.register('org-switcher', OrgSwitcherController);
application.register('lead-entry-switch', LeadEntrySwitchController);
application.register('insurance-lead', InsuranceLeadController);
application.register('purchased-admin', PurchasedAdminController);
application.register('demand', DemandController);
application.register('demand-staff', DemandStaffController);

export { application };
